import { render, staticRenderFns } from "./ProductsImportAdmin.vue?vue&type=template&id=52f07db0&scoped=true"
import script from "./ProductsImportAdmin.vue?vue&type=script&lang=js"
export * from "./ProductsImportAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f07db0",
  null
  
)

export default component.exports